module.exports = ".example-form {\n    min-width: 150px;\n    max-width: 500px;\n    width: 100%;\n  }\n  \n  .example-full-width {\n    width: 100%;\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/update-password/update-password.component.css
// module id = ./src/app/update-password/update-password.component.css
// module chunks = main